import React, { Component } from 'react';
import { Modal, Button, Tabs, Table, Pagination } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import TableC from '../../../basicElement/TableC';
import { tableColumns, tabs } from '../pageMes';


const TabPane = Tabs.TabPane;
const addTabs = [
    {
        tab:'在医院/科室下承担site leader/PCRC工作',
        key:'2',
    },{
        tab:'品牌维护',
        key:'3',
    },{
        tab:'带教新人',
        key:'-1',
    },{
        tab:'每季度项目量和入组量',
        key:'-2',
    },{
        tab:'培训分享',
        key:'4',
    },{
        tab:'正能量',
        key:'5',
    },
]
class AddScoreDetail extends Component {

    state = {
        visible: false,
        data:[],
        record:{},
        pagination: {
            current: 1,
            pageSize: 5,
        },
        activeKey:'2',
        menuType:tableColumns['2'].menuType,
    }

    show = record => {
        this.setState({ visible: true, record }, this.loadData)
    }

    loadData = () =>{
        const { pagination:{ current, pageSize }, menuType, record:{ userId, year, month }, pagination } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.user.queryPositionCrcDetailList,
            data: {
                limit:pageSize,
                menuType,
                userId,
                offset: current,
                isRecord:1,
                recordYear:year,
                recordMonth:month,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getRecordData = () => {
        const { record } = this.state;
        this.setState({ data:[{...record}] })
    }

    getColumns = () => {
        const { activeKey } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'indexNum',
            key: 'indexNum',
            width: 80,
        },{
            title: '时间',
            dataIndex: 'date',
            key: 'date',
            width: tableColumns[activeKey].timeWidth || 120,
            render: (text, record) => {
                const { date, beginYearMonth, endYearMonth, recordYearMonth } = record;
                return recordYearMonth ? recordYearMonth : date ? date.slice(0,10) : `${beginYearMonth}~${endYearMonth}`
            }
        }]
        columns.push( ...tableColumns[activeKey].childTable)
        tableColumns[activeKey].tableFile && columns.push(
            {
                title: '附件',
                key:'crcPostFileMetas',
                dataIndex: 'crcPostFileMetas',
                render: (text, record) => {
                    const fileList = text && text.length ? text.map((element, index) => {
                        return <span key={index}>
                                <a onClick={() => this.downLoadFile(element.fileMetaId)}>{element.name}</a>
                                <br />
                            </span>
                    }) : '-'
                    return fileList
                }
            },
        )
        return columns
    }

    //下载附件
    downLoadFile = (fileMetaId) => {
        const url = API_URL.user.downloadFileMeta;
        ExportUtil.export({fileMetaId}, null, url);
    }
    
    handleCancel = () => {
        this.setState({
            visible: false,
            data:[],
            record:{},
            pagination: {
                current: 1,
                pageSize: 5,
            },
            activeKey:'2',
            menuType:tableColumns['2'].menuType,
        })
    }

    export = () => {
        const { record:{ userId, year, month }, menuType } = this.state;
        ExportUtil.export({ userId, recordYear:year, recordMonth:month, isAdd:1, menuType }, null, API_URL.user.exportCrcPostRecord);
    }

    handleTableChange = params => {
        this.setState({
            ...params,
        }, this.loadData);
    }

    handleTabClick = activeKey => {
        this.setState({ 
            activeKey, 
            menuType: activeKey === '1' ? null: tableColumns[activeKey].menuType,
            pagination: {
                current: 1,
                pageSize: 5,
                total:1,
            }
        }, activeKey * 1 > 0 ? this.loadData : this.getRecordData);
    }

    getData = data => {
        const { pagination:{ current, pageSize } } = this.state;
        data.forEach((el, index) => {
            el.indexNum = index + 1 + (current - 1) * pageSize;
        })
        return data
    }

    render () {
        const { visible, data, pagination, activeKey, record } = this.state;
        return(
            <Modal
                title="加分明细"
                visible={visible}
                width={800}
                onCancel={this.handleCancel}
                footer={<Button onClick={this.handleCancel}>关闭</Button>}
                >
                    <div style={{ padding:'0 20px 20px 20px' }}>
                        <span>{`时间：${record.recordYearMonth}`}</span>
                        <Button style={{ float:'right' }} type="primary" onClick={this.export}>导出</Button>
                    </div>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {addTabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    <TableC
                        data={this.getData(data)}
                        pagination={pagination}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                    />
            </Modal>
        )
    }
}

export default AddScoreDetail


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/components/AddScoreDetail.js